import { Component } from 'react'
import { getNoBidClientStyle } from 'utils/helpers'
import s from './ClientCellRenderer.scss'
import { Link } from 'react-router-dom'

class ClientCellRenderer extends Component {
  render() {
    const { data, path } = this.props
    if (!data) return null
    const { company } = data
    if (!company) {
      return ''
    }

    const { id, name, noBid } = company
    return (
      <Link className={s.link} to={`/${path}/${id}`} style={getNoBidClientStyle(noBid)}>
        {name}
      </Link>
    )
  }
}

export default ClientCellRenderer
